<template>
  <b-form-textarea v-model="localValue" :rows="3" :max-rows="6" :readonly="readonly"></b-form-textarea>
</template>

<script>
  export default {
    name: 'o-textarea-control',

    props: {
      value: {
        default: null
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      localValue: ''
    }),

    mounted() {
      this.localValue = this.value
    },

    components: {},

    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.localValue = newVal
        }
      },
      localValue(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('input', newVal)
        }
      }
    },

    methods: {}
  }
</script>
